module.exports = __webpack_public_path__ + "img/WMA_music_icon@2x.07ccb375.png";